import "./CreatePitchArt.css";
import { compose } from "recompose";
import * as React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import PitchArtContainer from "../PitchArtWizard/PitchArtViewer/PitchArtContainer";
import { AppState } from "../store";
import { setLetterPitch, replaceSpeakers, setUploadId, resetLetters } from "../store/audio/actions";
import { AudioAction } from "../store/audio/types";
import { Speaker, FileEntry } from "../types/types";
import AudioAnalysis from "./AudioAnalysis";
import { withAuthorization } from "../Session";
import Header from "../Components/header/Header";
import { fillMissingFieldsInChildDoc, uploadAudio } from "./ImportUtils";
import { spinner } from "../Utils/LoadingSpinner";
import ReactGA, { initialize } from "react-ga";
import ReactFileReader from "react-file-reader";
import * as DEFAULT from "../constants/create";
import { withRouter } from "react-router-dom";
import { createRef } from "react";
import ReactDOM from 'react-dom'
import { NotificationManager } from "react-notifications";
import {
  setPitchArtDocId,
  setPitchArtCollectionId,
  setParentPitchArtDocumentData,
  setCurrentPitchArtDocumentData,
  setCurrentPitchArtVersions,
  updatePitchArtDetails,
  setListenedDocuments
} from "../store/pitchArt/pitchArtActions";
import PitchArtVersionSelector from "./PitchArtVersionSelector";
import { createCommonPitchArtDocument } from '../Create/ImportUtils';
import { getChildPitchArtVersions } from '../Create/ImportUtils';
import { CURRENT_PITCHART_DOCUMENT_DATA } from "../constants";
import { timeStamp } from "console";
import { AppActions } from "../store/appActions";
import * as constants from "../constants";
import { canUserVisitCreatePitchArtpPage } from './ImportUtils';
import { isStorageObjectNotFound } from "../Firebase/storageErrors";
import Box from "@material-ui/core/Box";



interface CreatePitchArtProps extends React.Component<CreatePitchArtProps, State> {
  speakers: Speaker[];
  history: any;
  sharedId: any;
  setLetterPitch: (
    speakerIndex: number,
    letterIndex: number,
    newPitch: number
  ) => void;
  replaceSpeakers: (speakers: Speaker[]) => void;
  setUploadId: (speakerIndex: number, uploadId: string, fileIndex: number) => void;
  resetLetters: (speakerIndex: number) => void;
  firebase: any;
  match: any;
  location: any;
  currentCollectionId: string;
  parentPitchArtDocumentData: any;
  currentPitchArtDocumentData: any;
  currentChildPitchArtVersions: any
  listenedDocuments: [];
  currentUserRole: string;
  setPitchArtCollectionId: (Id: string) => void;
  setParentPitchArtDocumentData: (data: any) => void;
  setCurrentPitchArtDocumentData: (data: any) => void;
  setCurrentPitchArtVersions: (data: any) => void;
  updatePitchArtDetails: (data: any) => void;
  setListenedDocuments: (data: any) => void;
}
interface VerticalLine {
  id: string;
  time: number;
}
interface State {
  files: any[];
  selectedFolderName: string;
  isLoading: boolean;
  owner: string;
  speakers?: Speaker[];
  pitchRange: Array<{
    minPitch: number;
    maxPitch: number;
  }>;
  pitchArt: {
    minPitch: number;
    maxPitch: number;
    minTime: number;
    maxTime: number;
    showAccentPitch: boolean;
    showSyllableText: boolean;
    showVerticallyCentered: boolean;
    showPitchArtLines: boolean;
    showLargeCircles: boolean;
    averageDotSize: "S" | "M" | "L";
    contourDotSize: "S" | "M" | "L";
    showTimeNormalization: boolean;
    showPitchScale: boolean;
    showPerceptualScale: boolean;
    showPitchArtImageColor: boolean;
    showMetildaWatermark: boolean;
    isPitchRangeLocked: boolean;
    lockedMaxPitch: number,
    lockedMinPitch: number,
    toneTranspositionSemitones: number;
  };
  isAChildVersion: boolean;
  parentDocumentId: string;
  verticalLines: VerticalLine[];
  audioUrl: string; // New state for the audio URL
  windowWidth: number;
}

class CreatePitchArt extends React.Component<
  CreatePitchArtProps,
  State
> {

  private pitchArtRef = createRef<any>();
  private customStyles = {
    content: {
      margin: 0,
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };
  private parentDocumentData = null;

  constructor(props: CreatePitchArtProps) {
    super(props);
    this.state = {
      owner: this.props.firebase.auth.currentUser.email,
      files: [],
      selectedFolderName: "Uploads",
      isLoading: false,
      pitchRange: new Array(DEFAULT.SPEAKER_LIMIT).fill(
        {
          minPitch: DEFAULT.MIN_ANALYSIS_PITCH,
          maxPitch: DEFAULT.MAX_ANALYSIS_PITCH
        }),
      pitchArt: {
        minPitch: DEFAULT.MIN_ANALYSIS_PITCH,
        maxPitch: DEFAULT.MAX_ANALYSIS_PITCH,
        minTime: DEFAULT.MIN_ANALYSIS_TIME,
        maxTime: DEFAULT.MAX_ANALYSIS_TIME,
        showAccentPitch: false,
        showSyllableText: false,
        showVerticallyCentered: true,
        showPitchArtLines: true,
        showLargeCircles: true,
        averageDotSize: "L",
        contourDotSize: "S",
        showTimeNormalization: true,
        showPitchScale: false,
        showPerceptualScale: true,
        showPitchArtImageColor: true,
        showMetildaWatermark: false,
        isPitchRangeLocked: false,
        lockedMaxPitch: DEFAULT.MAX_ANALYSIS_PITCH,
        lockedMinPitch: DEFAULT.MIN_ANALYSIS_PITCH,
        toneTranspositionSemitones: 0,
      },
      isAChildVersion: false,
      parentDocumentId: '',
      verticalLines: [],
      audioUrl: '',
      windowWidth: window.innerWidth,
    };
    this.loadPitchArtVersions = this.loadPitchArtVersions.bind(this);
    this.removeVersionsModal = this.removeVersionsModal.bind(this);
  }

  componentDidMount() {
    if (this.props.match.params.type) {
      this.listenForData(this.props.match.params.type, this.props.match.params.id);
    } else {
      this.props.updatePitchArtDetails({
        pitchArtDocId: null,
        collectionId: null,
        listenedDocuments: [],
        parentPitchArtDocumentData: null,
        currentPitchArtDocumentData: null,
        currentPitchArtVersions: []
      });
      this.getUserFiles();
    }
    this.loadUserPitchArtSettings();
    // event listener for window resize
    window.addEventListener("resize", this.setWindowWidth)
  }
  componentDidUpdate(prevProps) {

    if (this.props.currentUserRole != null && !canUserVisitCreatePitchArtpPage(this.props.currentUserRole)) {
      this.props.history.push('/home');
      return;
    }
    // Check for changes in the URL parameters
    const { type: newType, id: newId } = this.props.match.params;
    const { type: prevType, id: prevId } = prevProps.match.params;

    if (newType !== prevType || newId !== prevId) {
      // URL parameters have changed, trigger a reload
      this.listenForData(newType, newId);
    }
  }

  setWindowWidth = () => {
    this.setState({ windowWidth: window.innerWidth })
  }

  setAudioUrl = (url: string) => {
    this.setState({ audioUrl: url });
  };

  listenForData(collectionId: string, docId: string) {

    const navigationSource = this.props.location.state ? this.props.location.state.from : null;
    if (collectionId == undefined && docId == undefined && navigationSource === 'nav-link') {
      window.location.reload();
      return;
    }
    if (collectionId == undefined) return;
    if (docId == undefined) return;

    const self = this;
    const unsubscribe = this.props.firebase.firestore.collection(collectionId).doc(docId)
      .onSnapshot((doc) => {
        if (doc.data()) {
          const currentDocData = doc.data();

          const currentParentDocId = currentDocData.parentDocumentId;
          if (currentParentDocId != '' && currentParentDocId != null) {
            if (self.props.parentPitchArtDocumentData == null || (self.props.parentPitchArtDocumentData.id != currentParentDocId)) {
              self.loadParentPitchArtData(currentParentDocId, collectionId, currentDocData, docId);
            } else {
              self.setCurrentPitchArtData(currentDocData, docId, collectionId);
            }
          } else {
            if (collectionId != 'share') {
              self.props.updatePitchArtDetails({
                parentPitchArtDocumentData: { "id": docId, "data": JSON.parse(JSON.stringify(currentDocData)) },
                currentPitchArtVersions: [],
                listenedDocuments: []
              });
            }

            self.setCurrentPitchArtData(currentDocData, docId, collectionId);
          }
        } else {
          self.setState({ owner: self.props.firebase.auth.currentUser.email });
          self.props.history.push({ pathname: "/pitchartwizard" });
          self.props.updatePitchArtDetails({
            currentPitchArtVersions: [],
            listenedDocuments: []
          })
        }
      });
    /**
     * Maintaining list of Id's to unsubscribe listening on firetsore 
     * document when the document is deleted.
     */
    if (docId && unsubscribe) {
      let newList = [];
      newList = [...this.props.listenedDocuments];
      newList.push({ "id": docId, "unsubscribe": unsubscribe });
      this.props.setListenedDocuments(newList);
    }

  }
  /**
   * This method loads parent(original) pitch art if the current 
   * pitch art if a child(version) of another pitch art.
   * @param parentDocId 
   * @param collectionId 
   * @param currentPitchArtData 
   * @param currentDocId 
   */
  loadParentPitchArtData = async (parentDocId: string, collectionId: string, currentPitchArtData: any, currentDocId: string) => {
    const self = this;
    try {
      const documents = await getChildPitchArtVersions(this.props.firebase, collectionId, parentDocId, true);
      const parentDoc = documents.find((doc) => doc.id === parentDocId);
      const childVersions = documents.filter((doc) => doc.data.parentDocumentId === parentDocId);
      if (parentDoc != null)
        self.props.setParentPitchArtDocumentData(parentDoc);
      if (childVersions.length != 0) {
        self.props.setCurrentPitchArtVersions(childVersions);
      }
      self.setCurrentPitchArtData(currentPitchArtData, currentDocId, collectionId);

    } catch (e) {
      console.error("Error setting parent document data ", e);
    }

  }
  /**
   * This method loads the current pitch art document data, and sets the data
   * to necessary fields.
   * @param currentPitchArtData 
   * @param currentDocId 
   * @param collectionId 
   */
  setCurrentPitchArtData = (currentPitchArtData: any, currentDocId: string, collectionId: string) => {
    let newSpeakers = currentPitchArtData.speakers;
    let parentDocumentData = this.props.parentPitchArtDocumentData;

    if (newSpeakers === undefined && parentDocumentData != null) {
      newSpeakers = parentDocumentData.data.speakers;
    }

    if (newSpeakers === undefined) {
      newSpeakers = [{ uploadId: "" }];
    }
    newSpeakers.forEach((speaker) => {
      if (speaker.letters === undefined) { speaker.letters = []; }
    });
    this.props.replaceSpeakers(newSpeakers as Speaker[]);
    // deep copy
    let currentPitchArtUpdatedData = JSON.parse(JSON.stringify(currentPitchArtData));
    const { isPitchRangeLocked, lockedMinPitch, lockedMaxPitch } = this.state.pitchArt;
    currentPitchArtUpdatedData.pitchArt = {
      ...currentPitchArtUpdatedData.pitchArt,
      isPitchRangeLocked,
      lockedMinPitch,
      lockedMaxPitch,
    };
    if (parentDocumentData != null) {
      parentDocumentData = JSON.parse(JSON.stringify(parentDocumentData));
      currentPitchArtData = JSON.parse(JSON.stringify(currentPitchArtData));
      currentPitchArtUpdatedData = createCommonPitchArtDocument(parentDocumentData.data, currentPitchArtData);
    }

    if (currentPitchArtUpdatedData.pitchArt?.isPitchRangeLocked === undefined) {
      currentPitchArtUpdatedData.pitchArt.isPitchRangeLocked = false;
    }
    if (currentPitchArtUpdatedData.pitchArt?.lockedMinPitch === undefined) {
      currentPitchArtUpdatedData.pitchArt.lockedMinPitch = DEFAULT.MIN_ANALYSIS_PITCH;
    }
    if (currentPitchArtUpdatedData.pitchArt?.lockedMaxPitch === undefined) {
      currentPitchArtUpdatedData.pitchArt.lockedMaxPitch = DEFAULT.MAX_ANALYSIS_PITCH;
    }


    this.setState({ ...currentPitchArtUpdatedData },
      () => { this.getUserFiles(); });


    if (collectionId != 'share') {
      this.props.updatePitchArtDetails({
        collectionId: collectionId,
        currentPitchArtDocumentData: { "id": currentDocId, "data": currentPitchArtUpdatedData }
      });
    }

  }

  getUserPitchArtSettingsRef = () => {
    const email = this.props.firebase.auth.currentUser?.email;
    if (!email) return null;
    return this.props.firebase.firestore
      .collection("users")
      .doc(email)
      .collection("settings")
      .doc("pitchArt");
  };


  persistUserPitchArtSettingsPatch = async (patch: any) => {
    if (this.props.match.params.type !== undefined) return;

    const ref = this.getUserPitchArtSettingsRef();
    if (!ref) return;

    try {
      await ref.set(patch, { merge: true });
    } catch (e) {
      console.error("Failed to persist user pitchArt settings:", e);
    }
  };

  loadUserPitchArtSettings = async () => {
    if (this.props.match.params.type !== undefined) return; // skip share pages

    const ref = this.getUserPitchArtSettingsRef();
    if (!ref) return;

    try {
      const snap = await ref.get();
      const data = snap.data();

      if (!data) return;

      // Apply universal settings into local state
      this.setState((prev) => ({
        ...prev,
        pitchArt: {
          ...prev.pitchArt,
          isPitchRangeLocked: !!data.isPitchRangeLocked,
          lockedMinPitch:
            typeof data.lockedMinPitch === "number"
              ? data.lockedMinPitch
              : prev.pitchArt.lockedMinPitch,
          lockedMaxPitch:
            typeof data.lockedMaxPitch === "number"
              ? data.lockedMaxPitch
              : prev.pitchArt.lockedMaxPitch,
        },
      }));
    } catch (e) {
      console.error("Failed to load user pitchArt settings:", e);
    }
  };

  persistPitchArtPatch = (patch: any) => {
    if (this.props.match.params.type !== undefined) return;

    const collectionId = this.props.currentCollectionId;
    const docId = this.props.currentPitchArtDocumentData?.id;

    if (!collectionId || !docId) return;

    this.props.firebase.firestore
      .collection(collectionId)
      .doc(docId)
      .update(patch)
      .catch((e) => console.error("Failed to persist pitchArt patch:", e));
  };


  updatePitchArtValue = (inputName: string, inputValue: any) => {
    this.setState((prevState) => {
      // Build next state immutably
      const nextPitchArt = {
        ...prevState.pitchArt,
        [inputName]: inputValue,
      };

      const nextState = {
        ...prevState,
        pitchArt: nextPitchArt,
      };

      if (this.props.match.params.type !== undefined) {
        this.props.firebase.updateSharedPage(
          nextState,
          this.props.match.params.type,
          this.props.match.params.id
        );
        return nextState;
      }

      if (
        inputName === "isPitchRangeLocked" ||
        inputName === "lockedMinPitch" ||
        inputName === "lockedMaxPitch"
      ) {
        this.persistUserPitchArtSettingsPatch({
          [inputName]: inputValue,
        });
        return nextState;
      }

      // 2) If min/max changed WHILE locked -> also update universal locked min/max
      if (
        (inputName === "minPitch" || inputName === "maxPitch") &&
        nextPitchArt.isPitchRangeLocked
      ) {
        const clampedMin =
          typeof nextPitchArt.minPitch === "number" ? nextPitchArt.minPitch : prevState.pitchArt.minPitch;

        const clampedMaxRaw =
          typeof nextPitchArt.maxPitch === "number" ? nextPitchArt.maxPitch : prevState.pitchArt.maxPitch;

        const clampedMax = Math.min(clampedMaxRaw, 500);

        this.persistUserPitchArtSettingsPatch({
          lockedMinPitch: clampedMin,
          lockedMaxPitch: clampedMax,
        });

        nextState.pitchArt.lockedMinPitch = clampedMin;
        nextState.pitchArt.lockedMaxPitch = clampedMax;
      } else {
        // Non-lock fields: keep persisting to the pitch art document like you already do
        this.persistPitchArtPatch({
          [`pitchArt.${inputName}`]: inputValue,
        });
      }

      return nextState;
    });
  };


  updateAudioPitch = (index: number, minPitch: number, maxPitch: number) => {
    this.setState((prevState) => {
      const state = prevState;
      state.pitchRange[index].minPitch = minPitch;
      console.log("min pitch " + minPitch);
      state.pitchRange[index].maxPitch = maxPitch;
      console.log("max pitch " + maxPitch);
      // update in the pitch art too 
      if (this.props.match.params.type !== undefined) {
        this.props.firebase.updateSharedPage(this.state, this.props.match.params.type, this.props.match.params.id);
      }
      return state;
    });
  }


  createSharedPage = () => {

    this.setState({ speakers: this.props.speakers });

    const pageId = this.props.firebase.firestore.collection("share").add({
      ...this.state
    }).then((docRef) => {
      this.props.history.push({ pathname: `/pitchartwizard/share/${docRef.id}` });
      this.listenForData("share", docRef.id);
      NotificationManager.success(
        "Page Sharing Started. The URL can be shared with other MeTILDA users."
      );
    }).catch((error) => {
      console.error("Error adding document: ", error);
    });
  }

  isOwner = () => {
    if (this.state.owner === this.props.firebase.auth.currentUser.email) {
      return true;
    }
    return false;
  }

  deleteSharedPage = () => {
    if (this.isOwner()) {
      this.props.firebase.firestore.collection(this.props.match.params.type).doc(this.props.match.params.id).delete().then(() => {
        console.log("Sharing for this page is disabled");
      }).catch((error) => {
        console.error("Error removing doc: ", error);
      });
    }
    this.props.history.push({ pathname: `/pitchartwizard` });
    window.location.reload();
  }
  /**
   * 
   * @returns This method loads pitch art documents(versions) realted to the current document
   * if the current document is a verion of another(parent) document, it loads parent doc and all
   * other douments(versions) of parent document.
   * if current document is parent(original) document, it loads all the child verions of the document.
   */
  loadPitchArtVersions = async () => {
    console.log("Inside load pitch art versions");

    console.log(this.props.currentCollectionId);
    if (!this.props.currentCollectionId) {
      this.renderVersionsModal([], []);
      return;
    }


    let documents = [];
    if (this.props.currentPitchArtDocumentData && this.props.currentPitchArtDocumentData["id"] != null) {
      const currentDocData = this.props.currentPitchArtDocumentData;
      const parentDocId = currentDocData["data"].isAChildVersion ? currentDocData["data"].parentDocumentId : currentDocData["id"];

      if (this.props.currentChildPitchArtVersions.length == 0) {
        documents = await getChildPitchArtVersions(this.props.firebase, this.props.currentCollectionId, parentDocId, true);
      } else {
        documents = this.props.currentChildPitchArtVersions;
        const parent = documents.find((doc) => doc.id === parentDocId);
        if (!parent) {
          documents = [...documents, this.props.parentPitchArtDocumentData];
        }

      }
      if (documents.length == 0) {
        this.renderVersionsModal([], []);
        return;
      }

      const DocIds = documents.map((doc) => { return doc['id']; });

      const ref = this.props.firebase.storage.ref();

      const documentPaths = DocIds.map((docId) => {
        return 'thumbnails/' + this.props.currentCollectionId + '/' + docId;
      })
      const downloadURLPromises = documentPaths.map((path) => ref.child(path).getDownloadURL());
      const idToURLMap = {};
      // Use Promise.all to execute all the requests in parallel
      Promise.all(downloadURLPromises)
        .then((urls) => {
          // 'urls' is an array of download URLs in the same order as 'documentPaths'

          DocIds.forEach((docId, index) => {
            idToURLMap[docId] = urls[index];
          });
          console.log("idToURLMap :: ", idToURLMap);
          this.renderVersionsModal(documents, idToURLMap);

        })
        .catch((error) => {
          console.error("Error getting download URLs:", error);
        });
    }

  }

  onFileDeleted = async (file: FileEntry) => {
    // 1. Delete from Firebase Storage (missing objects still allow DB cleanup)
    const storageRef = this.props.firebase.uploadFile();
    try {
      await storageRef.child(file.path).delete();
    } catch (ex) {
      if (!isStorageObjectNotFound(ex)) {
        NotificationManager.error(`Failed to delete "${file.name}" from storage.`);
        return;
      }
    }

    // 2. Delete from database
    const formData = new FormData();
    formData.append("file_id", String(file.index));
    const response = await fetch("/api/delete-file", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData,
    });
    if (!response.ok) {
      NotificationManager.error(`Failed to delete "${file.name}" from database.`);
      return;
    }

    // 3. Remove from file list state
    this.setState((prev) => ({
      files: prev.files.filter((f) => f.name !== file.name),
    }));

    // 4. Reset any speaker slot that had this file active
    this.props.speakers.forEach((speaker, idx) => {
      if (speaker.uploadId === file.name) {
        this.props.setUploadId(idx, "", -1);
        this.props.resetLetters(idx);
      }
    });

    // 5. Show success notification
    NotificationManager.success(`"${file.name}" deleted successfully.`);
  }

  renderSpeakers = () => {
    if (this.props.match.params.type && this.state.speakers && this.props.match.params.id) {

      this.props.firebase.updateSharedPageSpeakers(this.props.speakers, this.props.match.params.type, this.props.match.params.id);
    }

    const activeFileNames = this.props.speakers.map((s) => s.uploadId).filter(Boolean) as string[];

    return this.props.speakers.map((item, index) => (
      <AudioAnalysis
        speakerIndex={index}
        key={`audio-analysis-${index}-${item.uploadId}`}
        firebase={this.props.firebase}
        files={this.state.files}
        minPitch={this.state.pitchRange[index].minPitch}
        maxPitch={this.state.pitchRange[index].maxPitch}
        parentCallBack={this.callBackSelectionInterval}
        updateAudioPitch={this.updateAudioPitch}
        setAudioUrl={this.setAudioUrl} // Pass the new callback
        userEmail={this.props.firebase.auth.currentUser.email}
        onFileDeleted={this.onFileDeleted}
        activeFileNames={activeFileNames}
        selectedFolderName={this.state.selectedFolderName}
        onBackClick={this.folderBackButtonClicked}
      />
    ));
  }

  formatFileName = (uploadId: string): string => {
    const splitIndex = uploadId.lastIndexOf(".");

    if (splitIndex !== -1) {
      return uploadId.slice(0, splitIndex);
    }

    return uploadId;
  }

  getUserFiles = () => {
    // Get files of a user

    const currentUserId = this.props.match.params.type === "share"
      ? this.state.owner
      : this.props.firebase.auth.currentUser.email;

    fetch(
      `/api/get-files-and-folders/${currentUserId}/${this.state.selectedFolderName}` +
      "?file-type1=Folder&file-type2=Upload",
      {
        method: "GET",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((data) =>
        this.setState({
          files: data.result.map((item: any) => {
            return {
              index: item[0],
              name: item[1],
              path: item[2],
              size: item[3],
              type: item[4],
              created: item[5],
              updated: item[6],
              user: item[7]
            };
          }).sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
          }),
        })
      );
  }

  fileSelected = async (files: any) => {
    this.setState({
      isLoading: true,
    });
    try {
      const response = await uploadAudio(files, this.props.firebase);
      this.getUserFiles();
      ReactGA.event({
        category: "Upload File",
        action: "User pressed Upload File button",
      });
    } catch (ex) {
      console.log(ex);
    }
    this.setState({
      isLoading: false,
    });
  }

  folderBackButtonClicked = async () => {
    await this.setState({
      selectedFolderName: "Uploads",
    });
    this.getUserFiles();
  }

  callBackSelectionInterval = (childSelectedFolderName: string) => {
    this.setState({
      selectedFolderName: childSelectedFolderName,
    });
    if (this.state.selectedFolderName !== "Uploads") {
      this.getUserFiles();
    }
  }

  renderPageOptions() {
    const { windowWidth } = this.state
    let classNameParams = "page-options waves-effect waves-light btn globalbtn";
    if (windowWidth < 1400) {
      classNameParams = "waves-effect waves-light btn globalbtn";
    }
    if (this.props.match.params.type === "share") {
      return (
        <>
          <button className={classNameParams}
            onClick={this.deleteSharedPage}>
            <i className="material-icons right">person_add</i>
            {this.isOwner()
              ? "Stop Sharing"
              : "Leave Page"
            }
          </button>
        </>
      );
    } else if (this.props.match.params.type !== undefined) {
      //No Options
    } else {
      return (
        <>
          <button className={classNameParams}
            onClick={this.createSharedPage}>
            <i className="material-icons left">info</i>
            <i className="material-icons right">person_add</i>
            {"Share Page"}
          </button>
          <p className="page-options-tooltiptext"> to share file with other MeTILDA users</p>
        </>
      );
    }
  }
  /**
   * This method loads the versions pop up and display the UI
   * two compare versions with each other.
   * @param words array of documents(both original and versions)
   * @param urls  array of urls to load thumbnails(images) of each document.
   */
  renderVersionsModal = (words, urls) => {
    words.sort((a, b) => b.data.createdAt - a.data.createdAt);
    if (this.props.parentPitchArtDocumentData && this.props.parentPitchArtDocumentData["data"]) {
      words = words.map((word) => {
        return fillMissingFieldsInChildDoc(word, this.props.parentPitchArtDocumentData);
      })
    }

    const modal = document.querySelector('.version-overlay');
    const pitchArtVersionSelector = <PitchArtVersionSelector words={words} removeVersionsModal={this.removeVersionsModal}
      urls={urls} collectionId={this.props.currentCollectionId} firebase={this.props.firebase} history={this.props.history}
      params={this.props.match.params}
      setCurrentPitchArtData={this.setCurrentPitchArtData} />;

    // Render the React component inside the modal
    ReactDOM.render(pitchArtVersionSelector, modal);
  }

  removeVersionsModal = () => {
    const modal = document.querySelector('.version-overlay');
    ReactDOM.unmountComponentAtNode(modal);
  }

  render() {
    const { isLoading, windowWidth } = this.state;
    const uploadId = this.props.speakers
      .map((item) => this.formatFileName(item.uploadId))
      .join("_");
    const callbacks = { listenForData: this.listenForData.bind(this) };

    let cloudUploadButtonParams = "UploadFile waves-effect waves-light btn globalbtn"
    let versionButtonParams = "versions waves-effect waves-light btn globalbtn"
    if (windowWidth < 1400) {
      cloudUploadButtonParams = "waves-effect waves-light btn globalbtn"
      versionButtonParams = "waves-effect waves-light btn globalbtn"
    }

    return (
      <div>
        <Header />
        {isLoading && spinner()}
        <Box style={{ display: "flex", paddingLeft: "5%", paddingRight: "5%" }}>
          <ReactFileReader
            fileTypes={[".wav"]}
            multipleFiles={false}
            handleFiles={this.fileSelected}
          >
            <button className={cloudUploadButtonParams}>
              <i className="material-icons left">info</i>
              <i className="material-icons right">cloud_upload</i>
              Upload File to cloud
            </button>
            <p className="upload-tooltiptext">Upload file from your laptop to MeTILDA</p>
          </ReactFileReader>

          <div className="pitchArt-version">
            <button className={versionButtonParams} onClick={this.loadPitchArtVersions}>
              <i className="material-icons left">info</i>
              <i className="material-icons right">history</i>
              Versions
            </button>
            <p className="version-tooltiptext">View different versions created in this session</p>
          </div>

          <div className="version-overlay"></div>
          <div>{this.renderPageOptions()}</div>
        </Box>
        <div className="CreatePitchArt">
          <div className="metilda-page-content">
            <div id="button-drop-down-image-side-by-side">
              <div id="drop-down-and-image">{this.renderSpeakers()}</div>
            </div>
            <div className="row">
              <PitchArtContainer
                ref={this.pitchArtRef}
                firebase={this.props.firebase}
                speakers={this.props.speakers}
                width={DEFAULT.AUDIO_IMG_WIDTH}
                height={DEFAULT.AUDIO_IMG_HEIGHT}
                setLetterPitch={this.props.setLetterPitch}
                uploadId={uploadId}
                pitchArt={this.state.pitchArt}
                updatePitchArtValue={this.updatePitchArtValue}
                data={this.state}
                callBacks={callbacks}               
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

}

const mapStateToProps = (state: AppState) => ({
  speakers: state.audio.speakers,
  currentCollectionId: state.pitchArtDetails.collectionId,
  parentPitchArtDocumentData: state.pitchArtDetails.parentPitchArtDocumentData,
  currentPitchArtDocumentData: state.pitchArtDetails.currentPitchArtDocumentData,
  currentChildPitchArtVersions: state.pitchArtDetails.currentPitchArtVersions,
  listenedDocuments: state.pitchArtDetails.listenedDocuments,
  currentUserRole: state.userDetails.currentUserRole,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<AppState, void, AppActions>
) => ({
  setLetterPitch: (
    speakerIndex: number,
    letterIndex: number,
    newPitch: number
  ) => dispatch(setLetterPitch(speakerIndex, letterIndex, newPitch)),
  replaceSpeakers: (
    speakers: Speaker[]
  ) => dispatch(replaceSpeakers(speakers)),
  setUploadId: (speakerIndex: number, uploadId: string, fileIndex: number) =>
    dispatch(setUploadId(speakerIndex, uploadId, fileIndex)),
  resetLetters: (speakerIndex: number) => dispatch(resetLetters(speakerIndex)),
  // setPitchArtDocId:(pitchArtDocId: string) => dispatch(setPitchArtDocId(pitchArtDocId)),
  setPitchArtCollectionId: (collectionId: string) => dispatch(setPitchArtCollectionId(collectionId)),
  setParentPitchArtDocumentData: (data: any) => dispatch(setParentPitchArtDocumentData(data)),
  setCurrentPitchArtDocumentData: (data: any) => dispatch(setCurrentPitchArtDocumentData(data)),
  setCurrentPitchArtVersions: (data: any) => dispatch(setCurrentPitchArtVersions(data)),
  updatePitchArtDetails: (data: any) => dispatch(updatePitchArtDetails(data)),
  setListenedDocuments: (data: any) => dispatch(setListenedDocuments(data))
});

const authCondition = (authUser: any) => !!authUser;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(authCondition)(withRouter(CreatePitchArt as any) as any));
